import { Typography } from '@mui/material';
import { HotKeyBox } from '../HotKeyBox';

interface EscHotKeyIconProps {
  isDisabled?: boolean;
}

export const EscHotKeyIcon = ({ isDisabled }: EscHotKeyIconProps) => {
  return isDisabled ? null : (
    <HotKeyBox
      hotkeyDisplay={<Typography variant="subtitle2">Esc</Typography>}
    />
  );
};
